module.exports = __webpack_public_path__ + "img/new-flyer-logo.32685b95.jpg";